export default __webpack_public_path__ + "static/media/0x17a7829cc1167ecda8b9668414a5405050846f8a.3179d795.svg";